import { render, staticRenderFns } from "./NotentransferMitglieder.vue?vue&type=template&id=45bcbb72&"
import script from "./NotentransferMitglieder.vue?vue&type=script&lang=js&"
export * from "./NotentransferMitglieder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports